module.exports = __webpack_public_path__ + "img/nodisponible.b625cc0d.png";